import { useState, useEffect } from 'react'
import img from '../img/flechaArriba.png'

import '../css/buttomUp.css'



const ButtonUp = () => {
    
    const [see, setSee] = useState(false);
    
    const changeSee = () =>{
        if (window.scrollY >= 200) {
            setSee(true)
        }else {
            setSee(false)
        }
    }
    useEffect(() => {
        changeSee()
      
        window.addEventListener('scroll',changeSee);
        return () => window.removeEventListener('scroll', changeSee);
      },[])
      
    const scrollToTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

  return (
    <img src={img} onClick={scrollToTop} className={see ? 'buttonActive' : 'buttonDesactive'} alt='boton-arriba'/>
  )
}

export default ButtonUp